import axios from 'axios';

import child from '@/specialist/services/api/group/child';
import groupActivity from '@/specialist/services/api/group/group-activity';
import { handleError } from '@/shared/services/api';

export default {
  baseUrl(id) {
    let url = `${window.api_url}/organization/groups`;
    if (id) url += `/${id}`;
    return url;
  },

  create(group) {
    return axios.post(this.baseUrl(), { group }).catch(handleError);
  },

  index(params, success) {
    if (!success) return axios.get(this.baseUrl(), { params });

    return axios.get(this.baseUrl(), { params }).then(success);
  },

  get(id, success) {
    if (success) return axios.get(this.baseUrl(id)).then(success).catch(handleError);

    return axios.get(this.baseUrl(id)).catch(handleError);
  },

  update(id, group, success, failure) {
    if (!success) return axios.patch(this.baseUrl(), { group });

    axios.patch(this.baseUrl(id), { group }).then(success).catch(failure);
  },

  destroy(id) {
    return axios.delete(this.baseUrl(id));
  },

  promiseUpdate(id, group) {
    return axios.patch(this.baseUrl(id), { group }).catch(handleError);
  },

  child,

  group_activity: groupActivity,

  applicationSummaries(groupId) {
    return axios.get(`${this.baseUrl(groupId)}/application_summaries`).catch(handleError);
  },

  householdMembers: {
    baseUrl(groupId, id) {
      let url = `${window.api_url}/organization/groups/${groupId}/household_members`;
      if (id) url += `/${id}`;
      return url;
    },

    index(groupId) {
      return axios.get(this.baseUrl(groupId)).catch(handleError);
    },

    update(groupId, householdMember) {
      return axios
        .patch(this.baseUrl(groupId, householdMember.id), { household_member: householdMember })
        .catch(handleError);
    },

    archive(groupId, id) {
      return axios.patch(`${this.baseUrl(groupId, id)}/archive`).catch(handleError);
    },

    reorder(groupId, id, params) {
      return axios.post(`${this.baseUrl(groupId, id)}/reorder`, params).catch(handleError);
    },
  },
};
